<script setup lang="ts">
import countries from '@/assets/countries.json';
import CreationFilter from '@/components/Menus/Filters/CreationFilter.vue';
import { type MessageSchema } from '@/i18n';
import { useAppStore } from '@/stores/appStore';
import MultiSelect from 'primevue/multiselect';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
const appStore = useAppStore();
const props = defineProps<{
  attributes: Array<{ id: number; name: string }>;
  restaurantAttributes: Array<{ id: number; name: string }>;
}>();

const emit = defineEmits(['updateCountries']);

const countryIdMap = new Map(props.attributes.map((attr) => [attr.name, attr.id]));

const allCountries = computed(() => {
  return countries.map((country) => ({
    ...country,
    id: countryIdMap.get(country.alpha2), // Lier les ID backend
  }));
});

const selectedCountries = ref(props.restaurantAttributes.map((attr) => attr.id));

watch(
  selectedCountries,
  (newValues, oldValues) => {
    // Determine additions and removals by comparing old and new values
    const newSet = new Set(newValues);
    const oldSet = new Set(oldValues);

    const added = newValues.filter((id) => !oldSet.has(id));
    const removed = oldValues.filter((id) => !newSet.has(id));

    added.forEach((id) => {
      console.log('Added country ID: ', id);
      emit('updateCountries', id);
    });

    removed.forEach((id) => {
      console.log('Removed country ID: ', id);
      emit('updateCountries', id);
    });
  },
  { deep: true },
);
</script>

<template>
  <CreationFilter>
    <template #title>{{ t('creationFilters.inspirations') }}</template>
    <template #content>
      <MultiSelect
        v-model="selectedCountries"
        multiple
        filter
        display="chip"
        class="w-full"
        :option-label="appStore.language"
        option-value="id"
        :options="allCountries"
        :virtual-scroller-options="{ itemSize: 50 }"
        :pt="{ root: { class: 'h-9 items-center' } }"
        :pt-options="{ mergeProps: true }"
        :placeholder="t('creationFilters.inspirationsDropdownLabel')"
      />
    </template>
  </CreationFilter>
</template>
